



import React, {useEffect, useRef, useState, useMemo, useCallback} from 'react';
import { styled } from '@mui/material/styles'; // Replace makeStyles with styled
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';
import { connect } from 'react-redux';
import { getAnalysisAnnotations } from '../getAnnotations';
import { giveStableUniqueNames } from '../variantIdentity';
import { variantFinder } from './variant_finder';
import { GPAP_Table_Toolbar } from './GPAP_Table_Toolbar';
import { getOMIMInfoElastic, getSigenesVariation } from '../../../../../../../../../services/api/get';
import { getChr } from '../../toolbar/tag_dialog/mapChrom';
import { withTranslation } from 'react-i18next';
// icons
import EnhancedTableHead from './EnhancedTableHead';
import GPAP_Table_Row from './gpap_table_row/GPAP_Table_Row';
import ErrorBoundaryGPAP from '../../../../../../../../../../ErrorBoundaryGPAP';

// MUI components
import Typography from '@mui/material/Typography'; // Updated import path
import Box from '@mui/material/Box'; // Updated import path
import MappedText from '../../../../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText';
import {makeStyles} from "@mui/styles";
import { renderToStringAlt } from '../../../../../../../../instand/reports/create-report/shared-components/renderToString';
import { useTranslation } from 'react-i18next';

const order_clinVar = ["P", "LP", "VUS", "C", "LB", "B", "Drug", "Other", "NA"]


function descendingComparator(a, b, orderBy, orderByNumeric, orderDir) {

    let default_null = orderByNumeric ? -1 : "NA";

    if(orderBy === "clinvar_clnsig"){

        let A = (a[orderBy] !== undefined) ? a[orderBy].split("|")[0] : "NA";
        let B = (b[orderBy] !== undefined) ? b[orderBy].split("|")[0] : "NA";
        return order_clinVar.indexOf(B) - order_clinVar.indexOf(A)
    }
    else{
        let term_one = (b[orderBy]!== undefined) ? b[orderBy]: default_null;
        let term_two = ( a[orderBy]!== undefined) ?  a[orderBy] : default_null;

        if (term_one < term_two) {
            return -1;
        }
        if (term_one > term_two) {
            return 1;
        }
        return 0;
    }


}

function getComparator(order, orderBy, orderByNumeric) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy, orderByNumeric, order)
        : (a, b) => -descendingComparator(a, b, orderBy, orderByNumeric, order);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}





const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        float: "left"
    },
    paper: {
        width: '100%',
        marginBottom: 8,

    },
    container: {
        maxHeight: 640,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));




function giveUniqueNames(data){
        return giveStableUniqueNames(data);
}

function GPAP_Table(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const INIT_RPP=10;
    const REQUEST_SIZE =  (window.config.max_sortable_svn_rows) ? window.config.max_sortable_svn_rows : 1000;
    const [rows,setRows] = useState(giveUniqueNames(props.data));
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('gene');
    const [orderByNumeric, setSortNumeric] = useState(false);
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(INIT_RPP);
    const [totalPages, setTotalPages] = useState(rows.length/INIT_RPP);
    const [loading, setLoading] = useState(false);
    const [currentFrom, setCurrentFrom] = useState(0);
    const [variantShow, setVariantShow] = useState([]);
    const [viewMode, setViewMode] = useState(true);
    const [OMIM, setOMIM] = useState([]);
    const [sigenesMatches, setSigenesMatches] = useState({});
    const [queryID, setQueryId] = useState(undefined);
    const [sortingAction, setSortingAction] = useState(false);

    const hasRunRef = useRef(false);
    const omimRequestIdRef = useRef(0); // Track current request ID
    const omimDebounceTimerRef = useRef(null); // For debouncing
    const sigenesRequestIdRef = useRef(0);
    const sigenesDebounceTimerRef = useRef(null);
    const rowsRef = useRef(rows);
    const dataRef = useRef(props.data);
    rowsRef.current = rows;
    dataRef.current = props.data;

    //Get OMIM data
    const omimUrls = () => {
        // Increment request ID to track this specific request
        const currentRequestId = ++omimRequestIdRef.current;
        const currentRows = rowsRef.current;
        const currentData = dataRef.current;
        //let rows_to_query = props.data.slice(page* rowsPerPage, page * rowsPerPage + rowsPerPage)
        let rows_to_query = (sortingAction) ? stableSort(currentRows, getComparator(order, orderBy, orderByNumeric)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : (currentData || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

        const promises = rows_to_query.map(item => {
            let gene = (item.gene_name !== "" ? item.gene_name : 'nothing');
        
            return getOMIMInfoElastic(config.apis_configuration.api_nextgpap_server_elastic, gene, props.token)
                .then(response => {
                    if (!response.ok) {
                        // If response status is not OK, throw an error
                        return { error: true };
                    }
                    return response.json();
                })
                .then(data => {

                    // If data is not an array or has length <= 1, return it as is
                    if (!data || !Array.isArray(data) || data.length <= 1) {
                        return data; 
                    }
                    
                    // Else, Sort the data based on the presence and position of the gene in geneSymbols
                    return data.sort((a, b) => {
                        const indexA = a.geneSymbols.indexOf(gene);
                        const indexB = b.geneSymbols.indexOf(gene);
        
                        // If gene is not found in both a and b, keep their original order
                        if (indexA === -1 && indexB === -1) return 0;

                        // If gene is not found in a but found in b, b comes first
                        if (indexA === -1) return 1;

                        // If gene is found in a but not in b, a comes first
                        if (indexB === -1) return -1;

                        // If gene is found in both, sort by the position of the gene
                        return indexA - indexB;
        
                    });
                })
                .catch(error => {
                    console.error('Fetch error:', error);
                    return { error: true };
                });
        });
      
        Promise.all(promises)
            .then(results => {
                // Only update state if this is still the latest request
                if (currentRequestId !== omimRequestIdRef.current) {
                    console.log('Skipping stale OMIM response');
                    return;
                }

                const numErrors = 5;

                // Mocking an array of Error instances
                //results = Array.from({ length: numErrors }, (_, index) => new Error(`Failed to fetch OMIM for index ${index}`));

                const _omims = results.map(result => {


              if (result instanceof Error || "error" in result) {
                  // Handle the case where the promise fails
                  return "Service Unavailable";
              } 

              //Directly from OMIM
              /*else if (result.omim.searchResponse.entryList.length > 0){

             let phenotype_list;

             if ((result.omim.searchResponse.entryList[0].entry.geneMap !== undefined) && (result.omim.searchResponse.entryList[0].entry.geneMap.phenotypeMapList !== undefined)){
               phenotype_list = result.omim.searchResponse.entryList[0].entry.geneMap.phenotypeMapList
             }

             else if (result.omim.searchResponse.entryList[0].entry.phenotypeMapList !== undefined) {
               phenotype_list = result.omim.searchResponse.entryList[0].entry.phenotypeMapList;
             } 

             else{
                phenotype_list = []
             }
              
              if ((phenotype_list && phenotype_list.length > 0)){

                let omim_results = phenotype_list.map(x => ({Phenotype: x.phenotypeMap.phenotype, Inheritance: x.phenotypeMap.phenotypeInheritance}))

                let f_omim_results = omim_results.map(function(item) {
                    let inheritance = (item["Inheritance"] !== null ? item["Inheritance"] : "Unknown inheritance")
                    let phenotype = item["Phenotype"]

                    return phenotype + "," + inheritance;
                  });
                
                return f_omim_results.join(";");
              }


              else{
                  return "No OMIM entry"
              }
             
            }*/


             //From our Elastic OMIM
             else if (result.length > 0){

             let phenotype_list = [];

             result.forEach((item) => {
                if (item.hasOwnProperty('phenotypeMapList')) {
                    item.phenotypeMapList.forEach((phenotypeMapObj) => {
                        if (phenotypeMapObj.hasOwnProperty('phenotypeMap')) {
                            phenotype_list.push(phenotypeMapObj);
                        }
                    });
                }
             });
             

             if ((phenotype_list && phenotype_list.length > 0)){

                let omim_results = phenotype_list.map(x => ({Phenotype: x.phenotypeMap.phenotype, Inheritance: x.phenotypeMap.phenotypeInheritance}))

                let f_omim_results = omim_results.map(function(item) {
                    let inheritance = (item["Inheritance"] !== null && item["Inheritance"] !== "" ? item["Inheritance"] : "Unknown inheritance")
                    let phenotype = item["Phenotype"]

                    return phenotype + "," + inheritance;
                  });
                
                return f_omim_results.join(";");
              }


              else{
                  return "No OMIM entry"
              }
             
            }


            else {
                return "No OMIM entry"
            }
          });

          setOMIM(_omims)
        })
            .catch(error => {
                // Only update state if this is still the latest request
                if (currentRequestId !== omimRequestIdRef.current) {
                    return;
                }
                // Handle any errors that occur during Promise.all
                return "Service Unavailable";
            })
            .finally(() => {
                // This block will execute regardless of whether the promises were resolved or rejected
                if (currentRequestId === omimRequestIdRef.current) {
                    console.log("All promises have been settled.");
                }
            });
    };

    // Debounced version of omimUrls - stable when only selection changes (rows/data refs used inside omimUrls)
    const debouncedOmimUrls = useCallback(() => {
        // Clear any existing timer
        if (omimDebounceTimerRef.current) {
            clearTimeout(omimDebounceTimerRef.current);
        }
        
        // Set a new timer
        omimDebounceTimerRef.current = setTimeout(() => {
            omimUrls();
        }, 300); // 300ms delay - adjust as needed
    }, [page, order, orderBy, orderByNumeric, rowsPerPage, sortingAction, props.token]);

    // Normalize the HGVSc/cDNA (codon_change) value shown in the "Nucleotide" column.
    // Returns null when there is nothing usable to send to SiGenes.
    const getSigenesHgvsc = (row) => {
        if (!row) {
            return null;
        }
        const raw = row.codon_change;
        if (raw === undefined || raw === null) {
            return null;
        }
        const value = String(raw).trim();
        if (!value || value === "NA") {
            return null;
        }
        return value;
    };

    // Build the lookup key used to identify a variant for SiGenes lookups.
    // Combines chromosomal position with HGVSc when available so that variants
    // sharing a coordinate but differing on the nucleotide change are queried separately.
    const getSigenesPositionKey = (row) => {
        if (!row || row.chrom === undefined || row.chrom === null || row.pos === undefined || row.pos === null) {
            return null;
        }
        const chr = getChr(String(row.chrom));
        const position = `chr${chr}:${row.pos}`;
        const hgvsc = getSigenesHgvsc(row);
        return hgvsc ? `${position}|${hgvsc}` : position;
    };

    // Parse the "chr<C>:<pos>:<ref>:<alt>" string returned in entry.computed.position.
    // Returns null if the value is missing or malformed.
    const parseSigenesComputedPosition = (entry) => {
        const computed = entry && entry.computed && entry.computed.position;
        if (!computed || typeof computed !== "string") {
            return null;
        }
        const parts = computed.split(":");
        if (parts.length < 4) {
            return null;
        }
        return { ref: parts[2], alt: parts[3] };
    };

    // Compute how many SiGenes entries match the row.
    // - If the row had a usable HGVSc, the request was already filtered server-side
    //   and we trust the full set of returned entries.
    // - Otherwise, we filter the entries by parsing entry.computed.position and
    //   keeping only those whose ref/alt match the row's ref/alt.
    const countSigenesMatchesForRow = (row) => {
        const key = getSigenesPositionKey(row);
        const entries = key ? sigenesMatches[key] : null;
        if (!entries || entries.length === 0) {
            return 0;
        }
        const hgvsc = getSigenesHgvsc(row);
        if (hgvsc) {
            return entries.length;
        }
        const rowRef = row && row.ref !== undefined && row.ref !== null ? String(row.ref) : null;
        const rowAlt = row && row.alt !== undefined && row.alt !== null ? String(row.alt) : null;
        if (!rowRef || !rowAlt) {
            return 0;
        }
        return entries.filter((parsed) => parsed && parsed.ref === rowRef && parsed.alt === rowAlt).length;
    };

    // Query SiGenes for each visible row and store the resulting matches by position key.
    const querySigenes = () => {
        const apiBase = window.config && window.config.apis_configuration
            ? window.config.apis_configuration.api_phenostore
            : null;
        if (!apiBase) {
            return;
        }

        const currentRequestId = ++sigenesRequestIdRef.current;
        const currentRows = rowsRef.current;
        const currentData = dataRef.current;

        const rowsToQuery = (sortingAction)
            ? stableSort(currentRows, getComparator(order, orderBy, orderByNumeric)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : (currentData || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

        const uniqueQueries = new Map();
        rowsToQuery.forEach((row) => {
            const key = getSigenesPositionKey(row);
            if (!key || uniqueQueries.has(key)) {
                return;
            }
            const chr = getChr(String(row.chrom));
            uniqueQueries.set(key, {
                position: `chr${chr}:${row.pos}`,
                hgvsc: getSigenesHgvsc(row),
            });
        });

        if (uniqueQueries.size === 0) {
            setSigenesMatches({});
            return;
        }

        const promises = Array.from(uniqueQueries.entries()).map(([key, { position, hgvsc }]) =>
            getSigenesVariation(apiBase, position, props.token, hgvsc)
                .then((response) => {
                    if (!response.ok) {
                        return null;
                    }
                    return response.json();
                })
                .then((payload) => {
                    if (!payload || !Array.isArray(payload.data) || payload.data.length === 0) {
                        return null;
                    }
                    const parsedEntries = payload.data
                        .map(parseSigenesComputedPosition)
                        // Keep unparsable entries only when the upstream call was filtered by HGVSc,
                        // since in that case we trust the response without ref/alt verification.
                        .filter((parsed) => parsed !== null || Boolean(hgvsc));
                    if (parsedEntries.length === 0) {
                        return null;
                    }
                    return { key, entries: parsedEntries };
                })
                .catch(() => null)
        );

        Promise.all(promises).then((results) => {
            if (currentRequestId !== sigenesRequestIdRef.current) {
                return;
            }
            const next = {};
            results.forEach((entry) => {
                if (entry) {
                    next[entry.key] = entry.entries;
                }
            });
            setSigenesMatches(next);
        });
    };

    // Debounced SiGenes lookups - mirrors the OMIM debounce pattern above.
    const debouncedQuerySigenes = useCallback(() => {
        if (sigenesDebounceTimerRef.current) {
            clearTimeout(sigenesDebounceTimerRef.current);
        }
        sigenesDebounceTimerRef.current = setTimeout(() => {
            querySigenes();
        }, 300);
    }, [page, order, orderBy, orderByNumeric, rowsPerPage, sortingAction, props.token]);


    // control Table Update when new data come in;
    useEffect(() => {

        if(props.loading!==loading ){
            setLoading(props.loading);
            setRows(giveUniqueNames(props.data));
            setVariantShow([]);
            setSelected([]);
        }
       /* else if(props.viewMode!==viewMode){
            setViewMode(props.viewMode);
            setRows(giveUniqueNames(props.data));
        }*/
        else if(props.data.length>0){
            if("acmg_verdict" in props.data[0]){
                setRows(giveUniqueNames(props.data));
            }
            setTotalPages(rows.length/rowsPerPage);
        }
        else if(props.data.length !== rows.length){
            // TODO: to carefully observe ....
            setRows(giveUniqueNames(props.data));
            setVariantShow([]);
            setSelected([]);

        }


    }, [props.loading, props.viewMode, props.data,  props.pid_array]); // Only re-run the effect if count changes

    // Reset to first page AND resync the table rows when SNV results change (new gene, switch to "All",
    // Show Participant Variants, etc.). props.total / dataLength are primitives that only change when the
    // results actually change, so this reliably refreshes the rows even when the main sync effect's branches
    // (e.g. the acmg_verdict check) would otherwise leave stale variants in the table.
    const dataLength = Array.isArray(props.data) ? props.data.length : 0;
    useEffect(() => {
        setPage(0);
        setRows(giveUniqueNames(props.data));
        setVariantShow([]);
        setSelected([]);
    }, [props.total, dataLength]);

    useEffect(() => {

        const isCNVSelected = props.cnv_selected_row.length !== 0;

        console.log("GPAP Table")
        if (isCNVSelected && variantShow.length>0 && selected.length>0) {
            setVariantShow([]);
            setSelected([]);
            saveVariantToStore([]);
        } else {
            console.log("Keep all the same :)");
        }

        hasRunRef.current = true;
    }, [props.cnv_selected_row.length]);


     // Run this only when the page changes to call omim
     useEffect(() => {
        // Clear OMIM immediately to show "Loading..."
        setOMIM([]); 

        if (!props.loading) {
            debouncedOmimUrls();
        }

        // if the query changes, bring the table again to page 0;
        if(queryID !== props.studySettings.current_query){
            setQueryId(props.studySettings.current_query);
            setPage(0);
            setTotalPages(rows.length/rowsPerPage);
        }

        // Cleanup function to clear debounce timer
        return () => {
            if (omimDebounceTimerRef.current) {
                clearTimeout(omimDebounceTimerRef.current);
            }
        };
    }, [
        props.studySettings.current_query,
        props.loading, 
        page,
        props.pid_array.length,
        rowsPerPage,
        debouncedOmimUrls
    ]);


     useEffect(()=> {
         updateSelectedVariantStatus();
     },[props.all_tagged_variants])

    useEffect(()=> {
        updateSelectedVariantStatus();
    },[props.all_tagged_variants])

     
     //Run this when the query tab changes to set default sorting props
     useEffect(()=> {
        setOrderBy('gene');
        setOrder('asc');
        setSortNumeric(false)
        setSortingAction(false)

    },[props.studySettings.current_query])


    //Run this when sorting is applied to call OMIM again
    useEffect(() => {
        // Clear OMIM immediately to show "Loading..."
        setOMIM([]);

        if (!props.loading) {
            debouncedOmimUrls();
        }
        
        // Cleanup function to clear debounce timer
        return () => {
            if (omimDebounceTimerRef.current) {
                clearTimeout(omimDebounceTimerRef.current);
            }
        };
    }, [order, orderBy, props.loading, debouncedOmimUrls]);

    // Trigger SiGenes lookups whenever the visible rows change.
    // The column (and therefore the API calls) is only enabled when `werfen_endpoint`
    // is configured in window.config.
    useEffect(() => {
        if (!window.config || !window.config.werfen_endpoint) {
            return undefined;
        }

        setSigenesMatches({});

        if (!props.loading) {
            debouncedQuerySigenes();
        }

        return () => {
            if (sigenesDebounceTimerRef.current) {
                clearTimeout(sigenesDebounceTimerRef.current);
            }
        };
    }, [
        props.studySettings.current_query,
        props.loading,
        page,
        rowsPerPage,
        order,
        orderBy,
        props.pid_array.length,
        debouncedQuerySigenes,
    ]);

    const visibleRows = useMemo(() => {
      const base = sortingAction
        ? stableSort(rows, getComparator(order, orderBy, orderByNumeric))
        : rows;

      return base.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [rows, page, rowsPerPage, sortingAction, order, orderBy, orderByNumeric,]);

    // Handle keyboard navigation
    const handleKeyDown = useCallback(
      (event) => {
        if (visibleRows.length === 0) return;

        const currentIndex = visibleRows.findIndex(
          (row) => row.uniqueName === selected[0]
        );
        if (currentIndex === -1) return;

        let newIndex = currentIndex;

        if (event.key === "ArrowDown") {
          newIndex = Math.min(currentIndex + 1, visibleRows.length - 1);
        } else if (event.key === "ArrowUp") {
          newIndex = Math.max(currentIndex - 1, 0);
        } else {
          return;
        }

        const newRow = visibleRows[newIndex];
        if (!newRow || newRow.uniqueName === selected[0]) return;

        const newSelected = [newRow.uniqueName];
        setSelected(newSelected);
        getSelectedItem(newSelected);

        requestAnimationFrame(() => {
          const rowElement = document.getElementById(
            `variant-row-${newRow.uniqueName}`
          );
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });

        event.preventDefault();
      },
      [visibleRows, selected, setSelected, getSelectedItem]
    );

    useEffect(() => {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }, [handleKeyDown]);
    
    const handleRequestSort = (event, property, numeric) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        setSortNumeric(numeric);
        setSortingAction(true);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.uniqueName );
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleClick = (event, name) => {


        console.log("GPAP Row clicked");
        // get position instead;
        if(Array.isArray(selected) && selected.includes(name)){
                setSelected([]);
                getSelectedItem([]);

        }
        else{
            setSelected([name]);
            getSelectedItem([name]);

        }
    };

    const handleChangePage = (event, newPage) => {

        let baseline = currentFrom/rowsPerPage;
        let p = (baseline + newPage);
        let range = [currentFrom/rowsPerPage, totalPages];
        let bool = (p<range[0] || p>=range[1]);

        if( bool )
        {
          // eg. currentFrom = 0
          // rowsPerPage= 25
          let current_from = (newPage >0 ) ? currentFrom + REQUEST_SIZE : currentFrom - REQUEST_SIZE;
          setCurrentFrom(current_from);
          props.fetchData(current_from);
          setLoading(true);
          // e.g. 2000/25= 80 pages loaded
          setTotalPages((current_from + REQUEST_SIZE)/rowsPerPage) ;
          setPage(0)
        }
        else{
            setPage(newPage);
            setLoading(false);
        }
    };


    const getSelectedItem = (newSelected) => {
        if (!newSelected || newSelected.length === 0) {
            // Clear state if no selection
            saveVariantToStore([]);
            setVariantShow([]);
            return;
        }

        // Filter rows based on selection
        const selectedRows = rows.filter(row => newSelected.includes(row.uniqueName));

        // Find the first selected row
        const firstRow = rows.find(row => row.uniqueName === newSelected[0]);

        if (!firstRow) {
            console.warn("First selected item not found in rows.");
            return;
        }

        // Add tagging information to the selected rows
        const taggedRows = selectedRows.map(row => ({
            ...row,
            isTagged: isFlagged(firstRow),
        }));

        // Update state
        saveVariantToStore(taggedRows);
        setVariantShow(taggedRows);
    };


    const getDataType = () => {

        return (props.somatic_samples && props.somatic_samples.length > 0) ? "SNV_Somatic" : "SNV_Germline";

    }

    const saveVariantToStore = (variant) => {

        const variant_type = getDataType() ;

        if(variant.length === 0){
            props.actions.resetRow({
                data_type: variant_type,
            })
        }
        else{
            props.actions.setSelectedTableRows({
                data_row : variant,
                data_type: variant_type,

            })
        }



    }

    const updateSelectedVariantStatus = () => {

        if(variantShow.length>0){
            let copyVariant = [...variantShow];

            copyVariant.forEach(function(d){
                d["isTagged"] = isFlagged(copyVariant[0]);
            })

            saveVariantToStore(copyVariant);
        }

    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTotalPages(rows.length/parseInt(event.target.value, 10));

    };


    const isSelected = (name) => selected.indexOf(name) !== -1;


    const isFlagged = (row) => {
        // chrom ,  start_pos, gene

        let annotations = getAnalysisAnnotations(props.studySettings, props.studyBucket);
        let tagged_variants = props.all_tagged_variants;

        let variant_found = variantFinder(row, annotations, tagged_variants, "SNV_Germline");

        if(variant_found!== undefined && variant_found.length!==0){

            return variant_found;
        }
        else{
            return false;
        }

    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);


    const getTableContent = () => {

        
        //OMIM data info for each row
        //let _sub_rows = rows.slice(page* rowsPerPage, page * rowsPerPage + rowsPerPage);
        let _sub_rows  = (sortingAction) ? stableSort(rows, getComparator(order, orderBy, orderByNumeric)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): rows.slice(page* rowsPerPage, page * rowsPerPage + rowsPerPage);


        if (OMIM.length > 0){
          _sub_rows.forEach(function(element, i) {  _sub_rows[i].omim = OMIM[i] });
        }

        else {
         _sub_rows.forEach(function(element, i) {  _sub_rows[i].omim = "Loading..." });
        }

        return  stableSort(rows, getComparator(order, orderBy, orderByNumeric))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {

                const flagged = isFlagged(row);
                // flagged somewhere else

                const isItemSelected = isSelected(row.uniqueName);
                const labelId = `enhanced-table-checkbox-${index}`;

                const sigenesCount = countSigenesMatchesForRow(row);

                return (
                  <GPAP_Table_Row
                        row={row}
                        index = {index}
                        flagged = {flagged}
                        isItemSelected = {isItemSelected}
                        labelId= { labelId }
                        handleClick = {handleClick}
                        type={props.type}
                        studySettings = {props.studySettings}
                        studyBucket = {props.studyBucket}
                        annotations_cols = {(rows.length!==0 && "acmg_verdict" in rows[0])}
                        dataType={getDataType()}
                        sigenesMatchCount={sigenesCount}
                  />
                );
            })
    };


        if(props.data.length === 0 && props.type=== "search_across" && (props.total > 0 || props.pid_array.length > 0)){
            return (
                <Box p={2}>
                    <Typography variant={"h6"}>
                        <MappedText text={"Click on a gene or experiment in the left panel, or select a participant from the table above to load variants."} />
                    </Typography>
                </Box>
            );
            }

        return (
            <div className={classes.root} id={"gpap_table"}>
                <Paper className={classes.paper} elevation={0}>
                    <ErrorBoundaryGPAP/>
                    <GPAP_Table_Toolbar
                        numSelected={selected.length}
                        selected={variantShow}
                        participants = {props.participants}
                        selectedExperiments = {props.selectedExperiments}
                        tagged_variants = {props.all_tagged_variants}
                        total={props.total}
                        type={props.type}
                        all_tagged_variants = { props.all_tagged_variants }
                        annotate_variants = {props.annotate_variants}
                        getAllTaggedVariants = {props.getAllTaggedVariants }
                        passAnnotations={ props.passAnnotations }
                        dataType={getDataType()}
                    />
                    <ErrorBoundaryGPAP/>
                    <TableContainer
                        id={"style-9"}
                        className={classes.container}>

                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}>
                            <EnhancedTableHead
                                type = {props.type}
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={props.total}
                                annotations_cols = {(rows.length!==0 && "acmg_verdict" in rows[0])}
                            />
                            <TableBody>
                                {(!loading)
                                    ? (rows.length>0)
                                        ? getTableContent()
                                        : <><TableRow></TableRow>
                                            <TableRow style={{background: "#fafafa"}}>
                                            <TableCell colSpan={20} align="center" style={{padding: "24px"}}>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontSize: '16px',
                                                        color: 'gray',
                                                        textAlign: 'left',
                                                        fontWeight: "bold",
                                                        paddingTop: "24px",
                                                        paddingLeft: "24px"
                                                    }}
                                                >
                                                    <MappedText text={"No variants have passed the selected filters."}/>
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontSize: '16px',
                                                        color: 'gray',
                                                        textAlign: 'left',
                                                        paddingLeft: "24px",
                                                        paddingBottom: "24px"
                                                    }}
                                                >
                                                    <MappedText text={"To display variants, try using less restrictive filters or expanding the gene list"}/>                                                
                                                </Typography>
                                            </TableCell>
                                        </TableRow></>
                                    : null }

                              {/*  {emptyRows > 0 && (
                                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}*/}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        labelRowsPerPage={t("Rows per page:")}
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                      /*  loading={loading}*/
                        onPageChange={handleChangePage}
                        nextIconButtonProps={{disabled: ( loading || rowsPerPage > rows.length || (Math.ceil(totalPages)-1) === page) }}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelDisplayedRows={({ from, to, count }) => {
                            const { t } = props;
                            let pageN = (currentFrom / rowsPerPage) + page;
                            let pageN_label = (pageN === 0) ? "1" : pageN + 1;
                            return t("table_pagination_range", {
                                page: pageN_label,
                                from: currentFrom + from,
                                to: currentFrom + to,
                                count: rows.length
                            });
                        }}
                        backIconButtonProps={{disabled: currentFrom/rowsPerPage + page === 0}}

                        /*ActionsComponent={TablePaginationActions}*/
                    />
                    
                </Paper>

            </div>
        );
    }





function mapStateToProps (state) {
    if(state.authorization!==undefined)
    {
        return {
            token: state.authorization.token,
            studySettings: state.studySettings,
            studyBucket: state.studyBucket,
            cnv_selected_row: state.selected_table_rows.find(s => s.data_type === "CNV").data_row,
            somatic_samples: state.sample_list.somatic_samples}
    }
    else{
        return {snv: []}
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch)
});


export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(GPAP_Table));
